import { IRequirementDefinitionUpdateRequest } from "@wingspanhq/payments/dist/interfaces";

import { updateRequirementDefinition } from "../../../services/requirementDefinitions/updateRequirementDefinition";
import { useWSMutation } from "../../helpers";
import {
  QUERY_REQUIREMENT_DEFINITION,
  QUERY_REQUIREMENT_DEFINITIONS_LIST,
  QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE
} from "../keys";

export const useMutationUpdateRequirementDefinition = (id: string) =>
  useWSMutation(
    (payload: IRequirementDefinitionUpdateRequest) =>
      updateRequirementDefinition(id, payload),
    {
      dependencies: [
        [QUERY_REQUIREMENT_DEFINITION, id],
        QUERY_REQUIREMENT_DEFINITIONS_LIST,
        QUERY_REQUIREMENT_DEFINITIONS_LIST_SIZE
      ]
    }
  );
